import React from "react";

const TemplateWaTeam = () => {
  return <div>TemplateWaTeam</div>;
};

export default TemplateWaTeam;
